import styled from '@emotion/styled';
import { darken } from 'polished';
import { Textarea as TextareaUiKit } from '@/ui-kit/Textarea';
import { Input as InputUiKit } from '@/ui-kit/Input';
import { Button } from '@/ui-kit/Button';
import { useThemeContext } from '@/features/theme';

export const Form = styled.form(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  };
});

export const QuestionLabel = styled.div(() => {
  return {
    display: 'flex',
    justifyContent: 'space-between',
  };
});

export const Textarea = styled(TextareaUiKit)(() => {
  return {
    minHeight: '60px',
    borderRadius: '8px',
  };
});

export const Input = styled(InputUiKit)(() => {
  return { borderRadius: '8px' };
});

export const StyledButton = styled(Button)(() => {
  const theme = useThemeContext();

  return {
    background: theme.primaryColor,
    ':hover': { background: darken(0.1, theme.primaryColor) },
    ':active': { background: darken(0.1, theme.primaryColor) },
    ':disabled': { background: theme.primaryColor },
  };
});
